/**
 * Nmeth Report Service (rpt_nmeth)
 * 新方法論報告 API 服務
 */

import axios from '../api/axios';

export interface SectionCompleteness {
  key: string;
  label_zh: string;
  label_en: string;
  percentage: number;
  has_data: boolean;
}

export interface NmethRptCompletenessData {
  proposal_id: number;
  proposal_title: string;
  overall_percentage: number;
  sections: SectionCompleteness[];
}

const BASE_URL = '/api/nmeth-rpt';

export const getNmethRptCompleteness = async (proposalId: number): Promise<NmethRptCompletenessData> => {
  const res = await axios.get<NmethRptCompletenessData>(`${BASE_URL}/completeness/${proposalId}`);
  return res.data;
};

export const getNmethRptHtmlReport = async (proposalId: number): Promise<string> => {
  const res = await axios.get<string>(`${BASE_URL}/html/${proposalId}`, {
    responseType: 'text',
  });
  return res.data;
};

export const downloadNmethRptPdfReport = async (proposalId: number, filename: string): Promise<void> => {
  const res = await axios.get(`${BASE_URL}/pdf/${proposalId}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(
    new Blob([res.data], { type: 'application/pdf' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default { getNmethRptCompleteness, getNmethRptHtmlReport, downloadNmethRptPdfReport };
